import { random, round2 } from "../helpers/helpers";

export const generate_busbar_line_demo = ({ start, end }) => {
    const result = [];

    const startDate = new Date(start);
    const endDate = new Date(end);
    const now = new Date();

    const cursor = new Date(startDate);
    cursor.setHours(0, 0, 0, 0);

    while (cursor <= endDate) {
        for (let h = 0; h < 24; h++) {
            for (let m = 0; m < 60; m += 30) {
                const pointTime = new Date(cursor);
                pointTime.setHours(h, m, 10, 0);

                // ❌ future protection
                if (pointTime > now) break;

                result.push({
                    device_time: `${pointTime.getFullYear()}-${String(
                        pointTime.getMonth() + 1
                    ).padStart(2, "0")}-${String(pointTime.getDate()).padStart(
                        2,
                        "0"
                    )} ${String(h).padStart(2, "0")}:${String(m).padStart(
                        2,
                        "0"
                    )}:10`,
                    temperature_b: round2(random(25.8, 26.9)).toFixed(2),
                    temperature_r: round2(random(25.5, 26.6)).toFixed(2),
                    temperature_y: round2(random(25.4, 26.5)).toFixed(2),
                });
            }
        }

        cursor.setDate(cursor.getDate() + 1);
    }

    return result;
};